import { render, staticRenderFns } from "./MapboxStaticMap.vue?vue&type=template&id=20e1b74f"
import script from "./MapboxStaticMap.vue?vue&type=script&lang=js"
export * from "./MapboxStaticMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports